var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.edit)?_c('v-select',{attrs:{"options":_vm.heatingOptions,"clearable":false,"reduce":(t) => t.name,"label":"label"},on:{"input":_vm.onInput},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}}):_c('span',{staticClass:"heating-type-picker"},[_vm._v(_vm._s(_vm.selectedLabel))])
}
var staticRenderFns = []

export { render, staticRenderFns }